import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

@translate(['geozones'], { wait: true })
export class NewGeozone extends Component{
  render(){
    const { t } = this.props
    return (
      <section className="garage-section garage-section_type_new">
        <div className="garage-section__content">
          <h3 className="garage-section__title_simple">{t('geozones:new-geozone__add')}</h3>
          <div className="garage-section__text">{t('geozones:new-geozone__description')}</div>
          <footer className="garage-section__footer">
            <button onClick={this.props.handleCreate} type="button" className="button"><span className="plus">+</span> {t('geozones:new-geozone__add')}</button>
          </footer>
        </div>
      </section>
    );
  }
}

NewGeozone.propTypes = {
  handleCreate: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Geozones/NewGeozone.js